module.exports = __webpack_public_path__ + "img/DownloadIcon.167befb6.svg";